/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Th7Inputs */

const en_mk_cmp_clickup_th7 = /** @type {(inputs: Mk_Cmp_Clickup_Th7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hundreds of integrations and a mature ecosystem.`)
};

const id_mk_cmp_clickup_th7 = /** @type {(inputs: Mk_Cmp_Clickup_Th7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratusan integrasi dan ekosistem yang matang.`)
};

/**
* | output |
* | --- |
* | "Hundreds of integrations and a mature ecosystem." |
*
* @param {Mk_Cmp_Clickup_Th7Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_th7 = /** @type {((inputs?: Mk_Cmp_Clickup_Th7Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Th7Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_th7(inputs)
	return en_mk_cmp_clickup_th7(inputs)
});